import UserMlsRoster from '@bb/domain/dist/types/UserMlsRoster';
import React, { useState, useEffect } from 'react';
import { getAllBoards } from '../../../../api/RetsController';

type AllBoardsType = Awaited<ReturnType<typeof getAllBoards>>;

type RosterType =
  | 'usermlsroster'
  | 'usermlsrosterinactive'
  | 'usermlsrosternonagent';

type RosterDataViewerPageContextType = {
  boards: AllBoardsType;
  setBoards: React.Dispatch<React.SetStateAction<AllBoardsType>>;
  roster?: UserMlsRoster;
  setRoster: React.Dispatch<React.SetStateAction<UserMlsRoster>>;
  rosterMlsNumber: string;
  rosterType: RosterType;
  setRosterType: React.Dispatch<React.SetStateAction<RosterType>>;
  setRosterMlsNumber: React.Dispatch<React.SetStateAction<string>>;
  rosterBoardId: string;
  setRosterBoardId: React.Dispatch<React.SetStateAction<string>>;
  rosterMlsUniqueId: string;
  setRosterMlsUniqueId: React.Dispatch<React.SetStateAction<string>>;
  updates?: UserMlsRoster;
  setUpdates: React.Dispatch<React.SetStateAction<UserMlsRoster | undefined>>;
};

const RosterDataViewerPageContext =
  React.createContext<RosterDataViewerPageContextType>(
    {} as RosterDataViewerPageContextType,
  );

export const RosterDataViewerPageProvider: React.FC = ({ children }) => {
  const [boards, setBoards] = useState<
    RosterDataViewerPageContextType['boards']
  >([]);
  const [roster, setRoster] =
    useState<RosterDataViewerPageContextType['roster']>();
  const [rosterType, setRosterType] = useState<RosterType>('usermlsroster');
  const [rosterMlsNumber, setRosterMlsNumber] = useState('');
  const [rosterBoardId, setRosterBoardId] = useState('');
  const [rosterMlsUniqueId, setRosterMlsUniqueId] = useState('');
  const [updates, setUpdates] =
    useState<RosterDataViewerPageContextType['updates']>();

  useEffect(() => {
    const fetchBoards = async () => {
      const res = await getAllBoards();
      setBoards(res);
    };
    fetchBoards();
  }, []);

  return (
    <RosterDataViewerPageContext.Provider
      value={{
        boards,
        setBoards,
        roster,
        setRoster,
        rosterType,
        setRosterType,
        rosterMlsNumber,
        setRosterMlsNumber,
        rosterBoardId,
        setRosterBoardId,
        rosterMlsUniqueId,
        setRosterMlsUniqueId,
        updates,
        setUpdates,
      }}
    >
      {children}
    </RosterDataViewerPageContext.Provider>
  );
};

export default RosterDataViewerPageContext;
